import $ from 'jquery'

$(document).on('turbolinks:load', function () {
  $('.chosen-select').chosen({ disable_search_threshold: 10 })
})
